
























import useAppData from "@/views/components/inbox/active-chat-sidebars/useAppData";
import { BOverlay } from "bootstrap-vue";
import { computed, defineComponent, onBeforeMount, onBeforeUnmount, onBeforeUpdate, ref } from "@vue/composition-api";
import { useToast } from "vue-toastification/composition";
import { useApps } from "@/composables/useApps";

export default defineComponent({
    components: {
        BOverlay,
    },
    props: {
        appId: {
            type: Number,
            required: true,
        },
    },
    setup(props: { appId: number }, { emit }) {
        const {
            appData,
            setActiveApp,
            isLoading: appDataIsLoading,
            setAppModalActive,
            appModalIsActive,
        } = useAppData();

        window.addEventListener("keyup", function (event) {
            if (event.keyCode === 27) {
                appModalIsActive.value = false;
            }
        });

        const { apps } = useApps();
        const toast = useToast();
        const rawData = ref(null);

        const updateApp = () => {
            setActiveApp(props.appId);
            app.value?.utils.setEmitAndToast(emit, toast);
        };

        onBeforeMount(updateApp);
        onBeforeUpdate(updateApp);
        onBeforeUnmount(() => {
            setActiveApp(null);
        });

        const app = computed(() => apps.value.find((app) => app.id === props.appId));

        const openAppModal = (appModalContent: any) => {
            setAppModalActive(appModalContent);
        };

        return {
            appData,
            isLoading: computed(() => (!appData.value && !app.value) || appDataIsLoading.value),
            app,
            openAppModal,
            rawData,
        };
    },
});
